<template>
  <div class="mt-6">
    <h4 class="mb-2">Scoring</h4>
    <v-card>
      <validation-observer ref="scoringFormObs" v-slot="{handleSubmit}">
        <form @submit.prevent="handleSubmit(getScoringData)">
          <v-card-text>
            <v-row dense>
              <v-col sm="3" cols="12">
                <custom-input-text
                    pattern="####-####-####-####"
                    label="Номер карты"
                    name="Номер карты"
                    rules="required"
                    vid="card_number"
                    v-model="scoringFormData.card_number"
                    placeholder="8888-8888-8888-8888"
                ></custom-input-text>
              </v-col>
              <v-col sm="3" cols="12">
                <custom-input-text
                    label="Срок действия"
                    rules="required"
                    name="Срок действия"
                    vid="expiry_date"
                    v-model="scoringFormData.card_expiry"
                    pattern="##/##"
                    placeholder="00/00"
                ></custom-input-text>
              </v-col>
              <v-col sm="3" cols="12">
                <custom-input-text
                    label="Сумма"
                    rules="required"
                    vid="amount"
                    v-model="scoringFormData.amount"
                ></custom-input-text>
              </v-col>
              <!--              <v-col sm="3" cols="12">-->
              <!--                <custom-input-text-->
              <!--                  label="Первоначальный взнос"-->
              <!--                  rules="required"-->
              <!--                  vid="expiry_date"-->
              <!--                  v-model="scoringFormData.initial_amount"-->
              <!--                ></custom-input-text>-->
              <!--              </v-col>-->
              <v-col sm="3" cols="12">
                <custom-select
                    rules="required"
                    label="Процент"
                    :items="percents"
                    item-text="text"
                    v-model="scoringFormData.percent"
                    item-value="value"
                ></custom-select>
              </v-col>
            </v-row>
            <div class="text-right">
              <v-btn :width="$vuetify.breakpoint.xs ? '100%' : null" color="primary" type="submit"
                     :disabled="!mko.can_scoring">Запустить скоринг
                {{ mko.price_katm_scoring ? '(' + mko.price_katm_scoring + ' сум)' : '' }}
              </v-btn>
            </div>
          </v-card-text>
        </form>
      </validation-observer>
    </v-card>
    <solvency-analysis :bank="bank" :user="user" :analysis="analysis" v-model="solvencyAnalysisDialog"/>
  </div>
</template>

<script>
import SolvencyAnalysis from "@/components/credit/SolvencyAnalysis";
import {GET_PERCENTS} from "@/utils/constants";
import {AnalysisCard} from "@/utils/AnalysisCard";
import {mapGetters} from 'vuex'

const scoringFormData = {
  card_number: null,
  card_expiry: null,
  amount: null,
  percent: null,
  initial_amount: 0
}

export default {
  name: 'scoring',
  data() {
    return {
      analysis: [],
      user: null,
      bank: null,
      percents: GET_PERCENTS(),
      scoringFormData,
      solvencyAnalysisDialog: false,
    }
  },
  watch: {
    solvencyAnalysisDialog(val) {
      if (!val) {
        const {scoringFormObs} = this.$refs
        this.scoringFormData = scoringFormData
        if (scoringFormObs) scoringFormObs.reset()
      }
    }

  },
  methods: {
    async getScoringData() {
      try {
        this.$showLoading()
        const {amount, initial_amount, card_number, card_expiry, percent} = this.scoringFormData
        let initialAmount = initial_amount ? parseInt(initial_amount) : 0
        const formData = {
          amount: (parseInt(amount) - initialAmount) * 100,
          card_number: card_number.replace(/-/g, ''),
          card_expiry,
          percent
        }
        const {data: {data}} = await this.$http.post('admin/scoring/by-card', formData)
        const analysisCard = new AnalysisCard(data)
        analysisCard.parseData()
        this.analysis = analysisCard.results.map(item => {
          return {
            text: `Проверки за ${item.date} по ${percent}%`,
            success: item.value
          }
        })
        this.bank = analysisCard.bank
        this.user = analysisCard.user
        this.solvencyAnalysisDialog = true
      } catch (e) {
        this.$setResponseError({error: e})
      } finally {
        this.$clearLoading()
      }
    }
  },
  components: {
    SolvencyAnalysis
  },
  computed: {
    ...mapGetters(['mko']),

  }
}
</script>
